<template>
  <div>
    <div
      v-if="isMobile"
      class="mobile-wrapper seller pointer"
      :class="{ active: isSelected }"
      @click="toUserMessage"
    >
      <div
        v-if="data.ad"
        class="image"
      >
        <vue-load-image v-if="data.ad.file">
          <img
            slot="image"
            class="item"
            :src="data.ad.file.url_view | resizeImage(62, 62)"
            :data-src="data.ad.file.url_view | resizeImage(62, 62)"
          >
          <div
            slot="preloader"
            v-loading="true"
            class="img-loading"
          >
            {{ $t('Loading ....') }}
          </div>
          <div slot="error">
            {{ $t('Network error') }}
          </div>
        </vue-load-image>
        <img
          v-else
          class="item"
          src="../../../assets/no-image.png"
        >
      </div>
      <div
        v-if="data.ad"
        class="about"
      >
        <h1 class="title">
          {{ data.ad.name | truncate(60) }}
        </h1>
        <span class="description">{{ data.ad.description_clean }}</span>
      </div>
      <div
        v-if="data.user"
        class="user-image position-relative"
      >
        <vue-load-image>
          <img
            v-if="data.user.file"
            slot="image"
            class="user"
            :src="data.user.file.url_view | resizeImage(48, 48)"
            :data-src="data.user.file.url_view | resizeImage(48, 48)"
          >
          <img
            v-else
            slot="image"
            class="user"
            src="../../../assets/profile-default.png"
            data-src="../../../assets/profile-default.png"
          >
          <div
            slot="preloader"
            v-loading="true"
            class="img-loading"
          >
            {{ $t('Loading ....') }}
          </div>
          <div slot="error">
            {{ $t('Network error') }}
          </div>
        </vue-load-image>
        <span
          v-if="data.unread_count"
          class="badge"
        >{{ data.unread_count }}</span>
      </div>
    </div>
    <div
      v-else
      @click="toUserMessage"
    >
      <el-row
        class="seller pointer"
        :class="{ active: isSelected }"
      >
        <el-col
          v-if="data.ad"
          :sm="7"
        >
          <vue-load-image v-if="data.ad.file">
            <img
              slot="image"
              class="item"
              :src="data.ad.file.url_view | resizeImage(62, 62)"
              :data-src="data.ad.file.url_view | resizeImage(62, 62)"
            >
            <div
              slot="preloader"
              v-loading="true"
              class="img-loading"
            >
              {{ $t('Loading ....') }}
            </div>
            <div slot="error">
              {{ $t('Network error') }}
            </div>
          </vue-load-image>
          <img
            v-else
            class="item"
            src="../../../assets/no-image.png"
          >
        </el-col>
        <el-col
          v-if="data.ad"
          :sm="12"
        >
          <h1 class="title">
            {{ data.ad.name }}
          </h1>
          <span class="description">{{ data.ad.description_clean }}</span>
        </el-col>
        <el-col
          v-if="data.user"
          :sm="5"
          class="position-relative"
        >
          <vue-load-image v-if="data.user.file">
            <img
              slot="image"
              class="user"
              :src="data.user.file.url_view | resizeImage(48, 48)"
              :data-src="data.user.file.url_view | resizeImage(48, 48)"
            >
            <div
              slot="preloader"
              v-loading="true"
              class="img-loading"
            >
              {{ $t('Loading ....') }}
            </div>
            <div slot="error">
              {{ $t('Network error') }}
            </div>
          </vue-load-image>
          <img
            v-else
            class="user"
            src="../../../assets/profile-default.png"
          >
          <span
            v-if="data.unread_count"
            class="badge"
          >{{ data.unread_count }}</span>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
  export default {
    // eslint-disable-next-line vue/require-prop-types
    props: ['data', 'isMobile', 'isSelected'],
    data() {
      return {
        testData: 'Aspernatur enim numquam maiores quisquam non.Aspernatur enim numquam maiores quisquam non.Aspernatur enim numquam maiores quisquam non.Aspernatur enim numquam maiores quisquam non.Aspernatur enim numquam maiores quisquam non.Aspernatur enim numquam maiores quisquam non.Aspernatur enim numquam maiores quisquam non.Aspernatur enim numquam maiores quisquam non.Aspernatur enim numquam maiores quisquam non.Aspernatur enim numquam maiores quisquam non.Aspernatur enim numquam maiores quisquam non.Aspernatur enim numquam maiores quisquam non.Aspernatur enim numquam maiores quisquam non.Aspernatur enim numquam maiores quisquam non.',
      };
    },
    methods: {
      toUserMessage() {
        this.data.unread_count = 0;
        this.$emit('selected', this.data);
        if (this.isMobile) {
          this.$router.push({
            name: 'UserMessage',
            params: {tab: this.$route.params.tab, userId: this.data.user_id, adId: this.data.ad_id}
          })
        }
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/AccountSettings/MessageUserList/Item.vue